module.exports = __webpack_public_path__ + "static/bg-pattern-fad4497a1cff1c1c91cd1e245fb27f8a.svg";